module.exports = __webpack_public_path__ + "img/reservationNumber.dc3ec224.svg";